import {
  scheduleStartHour,
  scheduleEndHour,
  scheduleStepMin,
} from './consts';

const generate = () => {
  const slots = [];
  const totalMinutes = (scheduleEndHour - scheduleStartHour) * 60;

  for (let minutes = 0; minutes < totalMinutes; minutes += scheduleStepMin) {
    const hour = Math.floor(minutes / 60) + scheduleStartHour;
    const min = minutes % 60;
    const label = new Date(0, 0, 0, hour, min).toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
    slots.push(label);
  }

  return slots;
};

export const timeSlots = generate();
